import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Create an account',
      description: 'Sign up with your email and protect your memories.',
    },
    {
      number: '2',
      title: 'Find or create',
      description: 'Browse the discover tab for open matches or start your own game.',
    },
    {
      number: '3',
      title: 'Join and play',
      description: 'Confirm your slot, show up at the pitch, and enjoy the game.',
    },
  ];

  return (
    <section className="bg-gradient-to-b from-dark via-darkGray to-dark py-20 px-4 md:px-8 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl -z-10"></div>
      
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <p className="text-red-500 font-semibold text-sm uppercase tracking-wider">How It Works</p>
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            Simple 3-Step Process
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">Join the PlayConnect community in just 3 simple steps</p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connection lines */}
          <div className="hidden md:block absolute top-20 left-1/4 right-1/4 h-1 bg-gradient-to-r from-transparent via-red-500/30 to-transparent"></div>
          
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Card */}
              <div className="card-base card-hover p-8 text-center h-full space-y-6">
                {/* Step Number Circle */}
                <div className="flex justify-center">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-600 rounded-full blur-lg opacity-40"></div>
                    <div className="relative w-20 h-20 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center shadow-lg shadow-red-500/30">
                      <span className="text-white text-3xl font-bold">{step.number}</span>
                    </div>
                  </div>
                </div>

                {/* Step Title */}
                <h3 className="text-2xl font-bold text-white">
                  {step.title}
                </h3>

                {/* Step Description */}
                <p className="text-gray-400 text-base leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {/* Arrow for next step */}
              {index < steps.length - 1 && (
                <div className="hidden md:flex absolute -right-16 top-20 items-center justify-center w-12 h-12">
                  <FiArrowRight className="w-6 h-6 text-red-500/30" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
